import {
  ProgramAutomationScheduleAnchor,
  type ProgramAutomationTaskScheduleTiming,
} from "@fitness-app/data-models/entities/ProgramAutomation";

export type PackageAnchoredScheduleTiming = Exclude<
  ProgramAutomationTaskScheduleTiming,
  { anchor: ProgramAutomationScheduleAnchor.WeekDay }
>;

export const isPackageAnchoredTiming = (
  timing?: ProgramAutomationTaskScheduleTiming | null,
): timing is PackageAnchoredScheduleTiming => !!timing && timing.anchor !== ProgramAutomationScheduleAnchor.WeekDay;

const formatDays = (days: number) => (Math.abs(days) === 1 ? `${Math.abs(days)} dzień` : `${Math.abs(days)} dni`);

export const getScheduleTimingLabel = (timing: PackageAnchoredScheduleTiming): string => {
  switch (timing.anchor) {
    case ProgramAutomationScheduleAnchor.PackageStart:
      return timing.offsetDays === 0
        ? "W dniu rozpoczęcia pakietu"
        : `${formatDays(timing.offsetDays)} po rozpoczęciu pakietu`;
    case ProgramAutomationScheduleAnchor.PackageEnd:
      if (timing.offsetDays < 0) {
        return `${formatDays(timing.offsetDays)} przed końcem pakietu`;
      }
      if (timing.offsetDays > 0) {
        return `${formatDays(timing.offsetDays)} po końcu pakietu`;
      }
      return "W dniu końca pakietu";
    case ProgramAutomationScheduleAnchor.PackageProgress: {
      const offset = timing.offsetDays ? ` (${timing.offsetDays > 0 ? "+" : "-"}${formatDays(timing.offsetDays)})` : "";
      return `Po ${timing.percent}% trwania pakietu${offset}`;
    }
  }
};
